/**
 * Card configuration for Raza dashboard (raza requests, lagat receipts, raza events).
 */
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import ReceiptIcon from "@mui/icons-material/Receipt";
import EventNoteIcon from "@mui/icons-material/EventNote";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import BookmarkAddedIcon from "@mui/icons-material/BookmarkAdded";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import type { SvgIconComponent } from "@mui/icons-material";

export type RazaDashboardCard = {
  permission: string;
  icon: SvgIconComponent;
  label: string;
  description: string;
  path: string;
};

export const RAZA_DASHBOARD_CARDS: RazaDashboardCard[] = [
  {
    permission: "razaRequests.view",
    icon: AssignmentTurnedInIcon,
    label: "Raza requests",
    description: "View and manage raza requests",
    path: "razaRequests",
  },
  {
    permission: "lagatReceipts.view",
    icon: ReceiptIcon,
    label: "Lagat receipts",
    description: "View and manage lagat receipts",
    path: "lagatReceipts",
  },
  {
    permission: "razaEvents.view",
    icon: EventNoteIcon,
    label: "Raza events",
    description: "Calendar, schedule and edit events",
    path: "raza-events",
  },
  {
    permission: "razaEvents.view",
    icon: CalendarMonthIcon,
    label: "Ohbat Attendance",
    description: "Upcoming and past ohbat majlis — record attendance",
    path: "razaEventsUpcoming",
  },
  {
    permission: "razaEvents.view",
    icon: PersonSearchIcon,
    label: "Allocate sadarat",
    description: "Fast-track queue for events missing sadarat",
    path: "razaEventsMissingSadarat",
  },
  {
    permission: "sadarats.view",
    icon: SupervisorAccountIcon,
    label: "Sadarats",
    description: "Sadarat master",
    path: "sadarats",
  },
  {
    permission: "makhsoosItsData.view",
    icon: BookmarkAddedIcon,
    label: "Makhsoos ITS",
    description: "Marks for sector matching",
    path: "makhsoosItsData",
  },
];
